import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'instantWheel', en);
i18next.addResources('fr', 'instantWheel', fr);

declare global {
  interface RegisteredLocales {
    instantWheel: typeof en;
  }
}
